import { type ResolvedContextData } from '@common/defaults/ContextData';
import { Route } from '@common/types/Route';
import { WidgetType } from '@common/types/Sidebar';
import { formatRoute } from '@common/utils/formatRoute';
import { getT, Ns } from '@web/i18n';
import { type TimelineItemProps } from '@web/molecules/NewsBlockItem/molecules/TimelineItem/types';
import { SimpleWidget } from '@web/organisms/SimpleWidget';
import { type SimpleWidgetConfig } from '@web/organisms/SimpleWidget/SimpleWidget.types';

import { RecentNewsContent, RecentNewsContentWithFetch } from './RecentNewsContent';

interface Props {
    contextData: ResolvedContextData;
    dataList?: TimelineItemProps[];
    adIndex?: number;
    children?: React.ReactNode;
}

export const widgetConfig: SimpleWidgetConfig = {
    title: 'recent-news.title',
    type: WidgetType.RECENT_NEWS,
};

export const Widget = (props: Props) => (
    <RecentNews {...props}>
        <RecentNewsContent {...props} />
    </RecentNews>
);

export const WidgetWithFetch = (props: Props) => (
    <RecentNews {...props}>
        <RecentNewsContentWithFetch {...props} />
    </RecentNews>
);

const RecentNews = ({ contextData, adIndex, dataList }: Props) => {
    const { context } = contextData;
    const __url = getT(context.locale, Ns.Url);
    const __sidebar = getT(context.locale, Ns.Sidebar);
    const title = __sidebar(widgetConfig.title);
    const titleUrl = formatRoute({ route: Route.RecentNews, context, contextData, __url });
    return (
        <SimpleWidget contextData={contextData} title={title} titleUrl={titleUrl}>
            <RecentNewsContent contextData={contextData} adIndex={adIndex} dataList={dataList} />
        </SimpleWidget>
    );
};
